export default __webpack_public_path__ + "static/media/mohren_logo_new.69a98a9f.svg";